import { createServiceStateApi } from './_serviceState';
const api = createServiceStateApi('periodic-reporting');
export const { getAllState, getState, patchState, putState, removeState } = api;
export default api;
